import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { ChipComponent } from '../../../../common-shared-module/components/chip/chip.component';
import { SingleFieldComponent } from '../../../../common-shared-module/components/single-field/single-field.component';
import { ToolHelpComponent } from '../../../../common-shared-module/components/tool-help/tool-help.component';
import { ItemTypeMetadata, itemTypeMetadataToIcon, ToItemTypeMetadata } from '../../../../common-shared-module/model/dyn-form/form-metadata/item-type-metadata.enum';
import { LayoutTypeMetadata } from '../../../../common-shared-module/model/dyn-form/form-metadata/layout-type-metadata.enum';
import { ExtendedLayoutMetadata } from '../../../../common-shared-module/model/dyn-form/form-metadata/layout/extends-layout.metadata.model';
import { WebServiceLayoutMetadataMethodTypeOptions, WebServiceLayoutMetadataTypeOptions } from '../../../../common-shared-module/model/dyn-form/form-metadata/webservice-layout-type-metadata.enum';
import { MetadataChange } from '../../../models/metadata-change.model';
import { sectionEditor } from '../../../models/tool-help.model';
import { WebServiceLayoutMetadata } from '../../../../common-shared-module/model/dyn-form/form-metadata/layout/webservice-layout-metadata.model';

@Component({
    selector: 'app-layout-metadata-editor',
    templateUrl: './layout-metadata-editor.component.html',
    styleUrl: './layout-metadata-editor.component.scss',
    standalone: true,
    imports: [
        ToolHelpComponent, ChipComponent, SingleFieldComponent, 
        MatIconModule, MatDividerModule, MatAccordion, MatExpansionModule, MatButtonModule,
        ReactiveFormsModule, CommonModule
    ]
})
export class LayoutMetadataEditorComponent {

    @Input() item!: ExtendedLayoutMetadata

    @Output() changeItem: EventEmitter<MetadataChange> = new EventEmitter()
    @Output() goParent: EventEmitter<boolean> = new EventEmitter()


    constructor() { }


    onGoParent() {
        this.goParent.emit(true)
    }

    icon(): string {
        return itemTypeMetadataToIcon(<ItemTypeMetadata> ToItemTypeMetadata(this.item.type))
    }

    helpText(): string {
        return sectionEditor.ItemTypeMetadataToHelpMsg(<ItemTypeMetadata> ToItemTypeMetadata(this.item.type))
    }

    fireChange() {
        let metadataChange = new MetadataChange()
        metadataChange.pushChanged(this.item)
        this.changeItem.emit(metadataChange)
    }

    fieldNameValidator = sectionEditor.fieldNameValidator

    isTableLayout(): boolean {
        return this.item.type == LayoutTypeMetadata.Table
    }

    isWebServiceLayout(): boolean {
        return this.item.type == LayoutTypeMetadata.WebService
    }

    isRepeatLayout(): boolean {
        return this.item.type == LayoutTypeMetadata.Repeat
    }

    getWebServiceTypes() {
        return WebServiceLayoutMetadataTypeOptions
    }

    getWebServiceItem(item: ExtendedLayoutMetadata) {
        return <WebServiceLayoutMetadata> item
    }

    getWebServiceMethodTypes() {
        return WebServiceLayoutMetadataMethodTypeOptions
    }

}
